import { Actions, ActionTypes } from './actions';
import { initialState, RelationshipState } from './state';

export function RelationshipReducer(state = initialState, action: Actions): RelationshipState {
  switch (action.type) {
    case ActionTypes.ALL_INVITELIST:
      return {
        ...state,
      };
    case ActionTypes.ALL_INVITE_COMPLETE:
      return {
        ...state,
        allInvites: action.payload,
      };
    case ActionTypes.IMPERSONATE_USER_RELATIONSHIPS:
      return {
        ...state,
        impersonateUserIdForReport: action.payload,
      };
    case ActionTypes.IMPERSONATE_USER_RELATIONSHIPS_COMPLETE:
      return {
        ...state,
        impersonateUserListForReport: action.payload,
      };

    case ActionTypes.ALL_RELATIONSHIPS:
      return {
        ...state,
        allRelationshipListLoading: true,
        impersonateUserId: action.payload,
      };
    case ActionTypes.ALL_RELATIONSHIPS_COMPLETE:
      return {
        ...state,
        allRelationshipListLoading: false,
        allRelationships: action.payload,
      };

    case ActionTypes.ALL_CLIENT_GROUPS:
      return {
        ...state,
      };
    case ActionTypes.ALL_CLIENT_GROUPS_COMPLETE:
      return {
        ...state,
        allClientGroups: action.payload,
      };
    case ActionTypes.MY_SUGGESTIONS:
      return {
        ...state,
      };
    case ActionTypes.MY_SUGGESTIONS_COMPLETE:
      return {
        ...state,
        MySuggestions: action.payload,
      };

    default: {
      return state;
    }
  }
}
